<template>
  <section class="contact-info-section">
    <div class="contact-info-desc" v-html="t('contactUs.info.desc')"></div>
    <div class="contact-info-row">
      <div class="contact-info-item" v-for="item in contactInfoItems" :key="item.label">
        <img :src="item.icon" :alt="item.label" />
        <div class="contact-info-label">{{ item.label }}</div>
        <div class="contact-info-value" v-html="item.value"></div>
      </div>
    </div>
  </section>
</template>
<script setup>
import { useI18n } from 'vue-i18n'
import { computed } from 'vue'
const { t, tm } = useI18n()
const contactInfoItems = computed(() => tm('contactUs.info.items'))
</script>
<style scoped>
.contact-info-section {
  width: 100%;
  text-align: center;
}

/* 使用 :deep() 穿透 scoped 样式 */
:deep(.desc_bold) {
  /* 需要适配 */
  font-size: 1.5rem;
}

.contact-info-desc {
  /* 需要适配 */
  font-size: 1rem;
  line-height: 3vh;
  padding-top: 50px;
  padding-bottom: 80px;
  background-color: #f7f7f7;
}

.contact-info-row {
  /* 需要适配 */
  width: 70%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 20px;
  margin: 100px auto;
}

.contact-info-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.contact-info-item:last-child {
  border-right: none;
}

.contact-info-item img {
  margin-bottom: 12px;
}

.contact-info-label {
  font-size: 1.2rem;
  margin-bottom: 20px;
}

.contact-info-value {
  color: #464444;
  font-size: 1rem;
}

/* 大屏幕设备 (1400px 以上) */
@media screen and (min-width: 1400px) {
  :deep(.desc_bold) {
    font-size: 1.4rem;
  }

  .contact-info-desc {
    font-size: 1.1rem;
    line-height: 1.7;
    padding-top: 50px;
    padding-bottom: 100px;
  }

  .contact-info-row {
    width: 70%;
    gap: 20px;
    margin: 100px auto;
  }

  .contact-info-item img {
    margin-bottom: 12px;
  }

  .contact-info-label {
    font-size: 1.4rem;
    margin-bottom: 20px;
  }

  .contact-info-value {
    font-size: 1.1rem;
  }
}

/* 笔记本电脑 */
@media screen and (max-width: 1399px) {
  :deep(.desc_bold) {
    font-size: 1.4rem;
  }

  .contact-info-desc {
    font-size: 1rem;
    line-height: 1.7;
    padding-top: 50px;
    padding-bottom: 80px;
  }

  .contact-info-row {
    width: 80%;
    gap: 20px;
    margin: 100px auto;
  }

  .contact-info-item img {
    margin-bottom: 12px;
  }

  .contact-info-label {
    font-size: 1.2rem;
    margin-bottom: 20px;
  }

  .contact-info-value {
    font-size: 1rem;
  }
}

/* 平板设备 */
@media screen and (max-width: 991px) {
  :deep(.desc_bold) {
    font-size: 1.3rem;
  }

  .contact-info-desc {
    font-size: 0.9rem;
    line-height: 1.7;
    padding-top: 50px;
    padding-bottom: 80px;
  }

  .contact-info-row {
    width: 94%;
    gap: 20px;
    margin: 100px auto;
  }

  .contact-info-item img {
    margin-bottom: 12px;
    width: 50px;
  }

  .contact-info-label {
    font-size: 1.1rem;
    margin-bottom: 20px;
  }

  .contact-info-value {
    font-size: 0.9rem;
  }
}

/* 手机设备 */
@media screen and (max-width: 767px) {
  :deep(.desc_bold) {
    font-size: 1.2rem;
  }

  .contact-info-desc {
    font-size: 0.8rem;
    line-height: 1.7;
    padding-top: 50px;
    padding-bottom: 70px;
  }

  .contact-info-row {
    width: 99%;
    gap: 20px;
    margin: 100px auto;
  }

  .contact-info-item img {
    margin-bottom: 12px;
  }

  .contact-info-label {
    font-size: 1rem;
    margin-bottom: 20px;
  }

  .contact-info-value {
    font-size: 0.8rem;
  }
}
</style>